import { render, staticRenderFns } from "./ecologyBanner.vue?vue&type=template&id=230cc3ee&scoped=true&"
import script from "./ecologyBanner.vue?vue&type=script&lang=js&"
export * from "./ecologyBanner.vue?vue&type=script&lang=js&"
import style0 from "./ecologyBanner.vue?vue&type=style&index=0&id=230cc3ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230cc3ee",
  null
  
)

export default component.exports